import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";
import { USER_ACTIVE_SCHOOL_YEAR, USER_SERVICE } from "../const/UserConst";

/**
 * Data Access for the User API
 * @name UserDao
 * @param props
 * @return {null|*}
 */
const UserDao = (props) => {
    const { action, token, username } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        }
    };
    switch (action) {
        case "activeSchoolYearRead":
            options.method = "GET";
            options.url = USER_ACTIVE_SCHOOL_YEAR;
            break;
        case "userDetailsRead":
            options.method = "GET";
            options.url = `${USER_SERVICE}/${username}/details.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

UserDao.propTypes = {
    action: PropTypes.string.isRequired,
    locKey: PropTypes.string,
    params: PropTypes.oneOfType([PropTypes.object]),
    token: PropTypes.string.isRequired,
    username: PropTypes.string
};

UserDao.defaultProps = {
    locKey: null,
    params: null,
    username: null
};

export default UserDao;
